<template>
  <top-bar />
  <div class="main-container container-fluid p-0">
    <slot />
  </div>
</template>

<script setup>
import TopBar from "@/components/Layout/TopBar.vue";
</script>